import React, { Component } from "react";

import { observer } from "mobx-react";

import {
    QuizObjectTable,
    QuizObjectTableColumn
} from "../../../../../../store/modquiz/quiz_objects/quiz-object";
import TableRow from "./TableRow";
import TableHead from "./TableHead";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import "./Style.css";

interface MyProps {
    table: QuizObjectTable;
}

class QuizObjectTableComponent extends Component<MyProps, any> {
    table: any;
    nameRef: any;

    constructor(props: any) {
        super(props);

        this.state = {
            counter: 0
        };

        this.nameRef = React.createRef();

        this.addTableRow = this.addTableRow.bind(this);
        this.addTableColumn = this.addTableColumn.bind(this);
        this.changeName = this.changeName.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.removeTable = this.removeTable.bind(this);
        this.restoreTable = this.restoreTable.bind(this);
        this.saveCellValue = this.saveCellValue.bind(this);
    }

    addTableRow() {
        this.props.table.addRow();
    }

    addTableColumn() {
        this.props.table.addColumn();
    }

    changeName(ev: any) {
        this.props.table.setName(ev.currentTarget.value);
    }

    removeTable() {
        this.props.table.remove();
    }

    restoreTable() {
        this.props.table.restore();
    }

    saveHeader(
        ev: React.FocusEvent<HTMLTableHeaderCellElement>,
        header: QuizObjectTableColumn
    ) {
        header.setTitle(ev.currentTarget.innerText);
    }

    saveCellValue(ev: any, cell: any, row: number, column: number) {
        cell.fromValueColumn.setValue(row, ev.currentTarget.innerText);
    }

    deleteRow(ev: any, row: number, column: number) {
        ev.preventDefault();
        this.props.table.deleteRow(row);
    }

    componentDidMount() {
        if (this.props.table.name == "") {
            this.nameRef.focus();
        }
    }

    render() {
        let tbodyHTML: JSX.Element;

        return (
            <div>
                <FormGroup>
                    <TextField
                        id="name"
                        onChange={this.changeName}
                        value={this.props.table.name}
                        inputRef={input => {
                            this.nameRef = input;
                        }}
                        className="form-control"
                        label="Table Name"
                    />
                </FormGroup>

                <table className="editable-table table">
                    <TableHead
                        saveHeader={this.saveHeader}
                        columns={this.props.table.columns}
                    />
                    <tbody>
                        {this.props.table.Rows.map(
                            (row: Array<any>, i: number) => {
                                return (
                                    <TableRow
                                        key={i}
                                        i={i}
                                        row={row}
                                        saveCellValue={this.saveCellValue}
                                        deleteRow={this.deleteRow}
                                    />
                                );
                            }
                        )}
                    </tbody>
                </table>

                <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                >
                    <Button onClick={this.addTableRow} color="primary">
                        + Row
                    </Button>
                    <Button onClick={this.addTableColumn} color="primary">
                        + Column
                    </Button>
                    <Button color="secondary" onClick={this.removeTable}>
                        Delete
                    </Button>
                    <Box
                        component="span"
                        color={
                            this.props.table.status == "error"
                                ? "secondary"
                                : "primary"
                        }
                    >
                        {this.props.table.status}
                    </Box>
                </div>
            </div>
        );
    }
}

export default observer(QuizObjectTableComponent);
